import { CROWDCAST } from '../constants';

export const isCrowdcast = (url: string): boolean => url.includes(CROWDCAST);
